"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardMenu = function CardMenu(_ref) {
  var menuIcon = _ref.menuIcon,
      menuItems = _ref.menuItems,
      menuAnchorEl = _ref.menuAnchorEl,
      menuHandlerClick = _ref.menuHandlerClick,
      menuHandlerClose = _ref.menuHandlerClose,
      menuIconPosition = _ref.menuIconPosition;
  var menuIconButtonClasses = (0, _styles.useMenuIconButtonStyles)({
    menuIconPosition: menuIconPosition
  });
  var menuClasses = (0, _styles.useMenuStyles)();
  var paperProps = {
    style: {
      maxHeight: 200,
      width: 150,
      borderRadius: 4
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-controls": "card-menu",
    "aria-haspopup": "true",
    className: menuIconButtonClasses.root,
    onClick: menuHandlerClick
  }, menuIcon), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    anchorEl: menuAnchorEl,
    id: "card-menu",
    open: Boolean(menuAnchorEl),
    onClose: menuHandlerClose,
    className: menuClasses.paper,
    PaperProps: paperProps,
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    keepMounted: true
  }, menuItems.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: item.label,
      onClick: item.click
    }, item.label);
  })));
};

exports.CardMenu = CardMenu;
CardMenu.propTypes = {
  // Icone do botão do menu Popover
  menuIcon: _propTypes.default.node,
  // Posicionamento do icone do menu
  menuIconPosition: _propTypes.default.oneOf(['left', 'right']),
  // Elemento HTML que define a posição do menu Popover
  menuAnchorEl: _propTypes.default.node,
  // Lista com dados dos item do menu Popover
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    click: _propTypes.default.func
  })),
  // Função responsável por abrir o menu Popover
  menuHandlerClick: _propTypes.default.func,
  // Função responsável por fechar o menu Popover
  menuHandlerClose: _propTypes.default.func
};
CardMenu.defaultProps = {
  menuIcon: _propTypes.default.instanceOf( /*#__PURE__*/_react.default.createElement(_icons.MoreVert, null)),
  menuIconPosition: 'right',
  menuAnchorEl: null,
  menuItems: null,
  menuHandlerClick: function menuHandlerClick() {},
  menuHandlerClose: function menuHandlerClose() {}
};